import { withMotionMax } from '@hoc/withMotionMax';
import { useHoverIntent } from '@hooks/useHoverIntent';
import SvgChevron from '@img/icons/chevron-right.svg';
import { useReducedMotion } from 'framer-motion';
import { debounce } from 'lodash';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../HeaderRevamped.styles';
const DesktopNavigation = (props) => {
    const [activeId, setActiveId] = React.useState('');
    const [currentParent, setCurrentParent] = React.useState('');
    const [currentSubParent, setCurrentSubParent] = React.useState('');
    if (!props.links) {
        return null;
    }
    const handleActivateChange = debounce((id) => {
        if (id) {
            setActiveId(id);
            setCurrentParent('');
            setCurrentSubParent('');
        }
        else {
            setActiveId('');
        }
    }, 50);
    return (React.createElement(S.DesktopNav, null,
        React.createElement(S.Outerlay, { "data-set-outerlay": activeId !== '', onClick: () => handleActivateChange('') }),
        React.createElement(S.Inner, { as: "ul" }, props.links.map((link) => (React.createElement(NavLink, { key: link.id, activeId: activeId, currentParent: currentParent, currentSubParent: currentSubParent, onActivateChange: handleActivateChange, onCurrentParent: (id) => setCurrentParent(id), onCurrentSubParent: (id) => setCurrentSubParent(id), ...link }))))));
};
const NavLink = (props) => {
    const shouldReduceMotion = useReducedMotion();
    const { ref: anchorRef } = useHoverIntent({
        onHover() {
            props.onActivateChange(props.id);
        },
        onBlur() {
            props.onActivateChange('');
            props.onCurrentParent('');
        },
    });
    return (React.createElement(S.DesktopNavItem, { ref: anchorRef, tabIndex: props.activeId !== props.id ? -1 : undefined, "data-is-active": props.activeId === props.id, animate: props.activeId === props.id ? 'open' : 'closed', initial: props.activeId === props.id ? 'open' : 'closed' },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.DesktopPrimaryNavLink, { href: props.url, target: "_self", onTouchEnd: (e) => props.activeId !== props.id && props.children.length > 0
                    ? (console.log('touchend', props.children.length),
                        e.preventDefault(),
                        props.onActivateChange(props.id))
                    : undefined },
                props.text,
                " ",
                props.children && props.children.length > 0 && React.createElement(SvgChevron, null))),
        props.children.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(S.DropdownMenuColumnFirst, { variants: {
                    open: {
                        height: 'auto',
                        overflow: 'visible',
                    },
                    closed: {
                        height: 0,
                        overflow: 'hidden',
                    },
                }, transition: shouldReduceMotion ? { duration: 0 } : { ease: [0.45, 0.01, 0.1, 1], duration: 0.15 } },
                props.children.map((link) => (React.createElement(S.DropdownMenuItem, { key: link.id, onMouseEnter: () => (props.onCurrentParent(link.id), props.onCurrentSubParent('')), onTouchEnd: (e) => props.currentParent !== link.id && link.children && link.children?.length > 0
                        ? (e.preventDefault(), props.onCurrentParent(link.id))
                        : undefined, "data-is-active": props.currentParent === link.id },
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.DropdownMenuLink, { href: link.url, target: link.target },
                            link.text,
                            " ",
                            link.children && link.children.length > 0 && React.createElement(SvgChevron, null)))))),
                props.children.map((col, index) => {
                    if (!col.children || col.children.length == 0) {
                        return null;
                    }
                    return (React.createElement(S.DropdownMultiLinkSection, { key: `dropdown-${props.id}-0${index + 1}`, "data-is-active": props.currentParent === col.id }, col.children?.map((group, i) => (React.createElement(S.DropdownMenuColumn, { key: `${col.id}-menu-col-${i}`, "data-no-group": !group.children || group.children.length === 0 }, group.children && group.children.length > 0 ? (React.createElement(React.Fragment, null,
                        React.createElement(S.DropdownMenuItem, { "data-group-header": true, "data-is-active": props.currentSubParent === group.id },
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.DropdownMenuLink, { href: group.url, target: group.target, onMouseEnter: () => props.onCurrentSubParent(group.id), onTouchEnd: (e) => props.currentSubParent !== group.id &&
                                        group.children &&
                                        group.children?.length > 0
                                        ? (e.preventDefault(), props.onCurrentSubParent(group.id))
                                        : undefined },
                                    group.text,
                                    React.createElement(SvgChevron, null)))),
                        React.createElement(S.DropdownMenuColumnThird, { "data-is-active": props.currentSubParent === group.id }, group.children.map((link) => (React.createElement(S.DropdownMenuItem, { key: link.id },
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.DropdownMenuLink, { href: link.url, target: link.target },
                                    link.text,
                                    link.children && link.children.length > 0 && React.createElement(SvgChevron, null))))))))) : (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.DropdownMenuItem, { "data-group-header": true, "data-is-active": props.currentSubParent === group.id },
                            React.createElement(S.DropdownMenuLink, { href: group.url, target: group.target, onMouseEnter: () => props.onCurrentSubParent(group.id) },
                                group.text,
                                group.children && group.children.length > 0 && React.createElement(SvgChevron, null))))))))));
                }))))));
};
export default withMotionMax(DesktopNavigation);
